import { combineReducers } from "redux";

import termsofservice from "../features/admin/termsofservices/termsofservice/Slice";

import common from "../features/admin/common/Slice";

const termsofservices = combineReducers({
  termsofservice,
  common,
});

export default termsofservices;